/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type DropDownAutoComplete_user$ref = any;
export type EventsDropDown_user$ref = any;
export type EventsDropDown_user = {
    readonly " $fragmentRefs": DropDownAutoComplete_user$ref;
    readonly " $refType": EventsDropDown_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "EventsDropDown_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "DropDownAutoComplete_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'ff9c68aa59e3e55c171cb7ed32682ef5';
export default node;
